import {
  CaesarsButton,
  ContainerHeader,
  LoadingOverlay,
  useIsAndroid,
  useIsDesktop,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';
import FA5ProIcon from 'react-native-vector-icons/FontAwesome5Pro';
import {useTheme} from 'styled-components/native';

export interface GatedProfilePanelPropTypes {
  children?: React.ReactNode;
  panelTitle: string;
  iconName: string;
  contentHeight?: number;
  onPrimaryPress: () => void;
  mfaOptinStatus: boolean | undefined;
  testID?: string;
  isLoading: boolean;
}

const GatedProfilePanel: React.FC<GatedProfilePanelPropTypes> = props => {
  const {
    children,
    contentHeight = 584,
    panelTitle,
    iconName,
    mfaOptinStatus,
    onPrimaryPress,
    testID,
    isLoading,
  } = props;
  const isDesktop = useIsDesktop();
  const isAndroid = useIsAndroid();
  const isWeb = useIsWeb();
  const theme = useTheme();
  const {white, ghostWhite, tuna, caesarRewards, black, athens} = theme.colors;

  const testIdPrefix = mfaOptinStatus ? 'step-up' : 'opt-in';
  const testIdCore = testID ? testID : 'empty';

  const headerTitleText = mfaOptinStatus
    ? 'Two-Step verification required'
    : 'Enroll in Two-Step verification';
  const headerDescriptionText = mfaOptinStatus
    ? 'Verify to view or edit your secured information.'
    : "Protecting your account is important to us. Let's enroll.";

  const getHeaderDescriptionLineHeight = () => {
    if (isWeb && !isDesktop) {
      return '20px';
    }

    if (isAndroid) {
      return undefined;
    }

    return '25px';
  };

  const GatedProfileHeader = (
    <View
      backgroundColor={isDesktop ? ghostWhite : white}
      height={isDesktop ? '132px' : undefined}
      maxWidth={isDesktop ? '1080px' : undefined}
      padding={isDesktop ? 7 : 5}
      justifyContent={isDesktop ? 'space-between' : undefined}
      alignItems={isDesktop ? undefined : 'center'}
      flexDirection={isDesktop ? 'row' : 'column'}
      borderBottomColor={isDesktop ? undefined : athens}
      borderBottomWidth={isDesktop ? undefined : '1px'}>
      <View
        height="50px"
        justifyContent="center"
        alignItems="center"
        flexDirection="row"
        width={isDesktop ? undefined : '100%'}
        marginBottom={isDesktop ? undefined : '12px'}>
        <FA5ProIcon
          size={isDesktop ? 35 : 18}
          color={black}
          name="shield-check"
          solid
        />
        <View
          flexDirection="column"
          justifyContent="center"
          paddingLeft="16px"
          width={isDesktop ? '100%' : '90%'}>
          <Text
            fontFamily="heading"
            fontWeight={700}
            fontSize={isDesktop ? '16px' : 1}
            lineHeight={isAndroid ? undefined : '17px'}
            marginBottom="4px"
            color={tuna}
            textTransform="uppercase">
            {headerTitleText}
          </Text>
          <Text
            fontFamily="body"
            fontSize={isDesktop ? '16px' : 1}
            lineHeight={getHeaderDescriptionLineHeight()}
            width="100%">
            {headerDescriptionText}
          </Text>
        </View>
      </View>
      <View
        width={isDesktop ? undefined : '100%'}
        alignSelf={isDesktop ? undefined : 'stretch'}
        justifyContent="center">
        <CaesarsButton
          title="Continue"
          onPress={onPrimaryPress}
          color={caesarRewards}
          isFullWidth={!isDesktop}
        />
      </View>
    </View>
  );

  return (
    <View
      flexDirection="column"
      shadow={isDesktop ? 0 : undefined}
      maxWidth={isDesktop ? '1018px' : '100%'}
      overflow="hidden"
      testID={`${testIdPrefix}-${testIdCore}-gated-module`}>
      <LoadingOverlay isLoading={isLoading} />
      {!isLoading && GatedProfileHeader}
      <View
        backgroundColor={white}
        padding={isDesktop ? 8 : 5}
        flexDirection="column">
        <View marginBottom={isDesktop ? '32px' : '24px'}>
          <ContainerHeader title={panelTitle} icon={iconName} />
        </View>
        {children}
      </View>
    </View>
  );
};

export default GatedProfilePanel;
